import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { apiProvider } from '../../api';
import { ZakazkaDropdownList } from './state';
import { mutations } from './mutations';
import { NAME, CRUMB_LABEL_KEY } from '../../constants';

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: new ZakazkaDropdownList(),
	filter: {
		EtdPrp: null as boolean | null,
		VyrazenPrp: false as boolean | false,
		NabidkaPrp: false as boolean | false,
		PripravaPrp: false as boolean | false,
		OtevrenePrp: false as boolean | false,
		UvolnenePrp: false as boolean | false,
		UzavrenePrp: false as boolean | false,
		ProvozovnaId: null as number | null,
		ZakazkaDruh: null as string | null,
		ZakazkaNr: null as number | null,
		ZakazkaText: null as string | null,
		VyrobekvozOzn: null as string | null,
		Spz: null as string | null,
		KaroserieNr: null as string | null,
		ZakazkaNrRef: null as number | null,
		ZakaznikId: null as number | null,
		ZakaznikIdText: null as string | null,
		VstupPracId: null as number | null,
		VstupPracIdText: null as string | null,
		VstupPracOsobniCis: null as string | null,
		VstupDatOd: null as string | null | Date,
		VstupDatDo: null as string | null,
		OtevreniDatOd: null as string | null,
		OtevreniDatDo: null as string | null,
		UzavreniDatOd: null as string | null,
		UzavreniDatDo: null as string | null,
		PnvId: null as number | null,
		PovId: null as number | null,
		OzakazkaId: null as number | null,
		OzakazkaIdText: null as string | null,
		OzakazkaIdNr: null,
		DokladPfx: null as string | null,
		DokladNr: null as number | null,
		CekajiciRyoPrp: null as boolean | null,
		DzmPrp: null as boolean | null,
		ZakazkyUzivatelePrp: null as boolean | null,
		PojistovnaId: null as number | null,
		PojistovnaIdText: null as string | null,
		LeaszakaznikId: null as number | null,
		LeaszakaznikIdText: null as string | null,
		LeasCisSchval: null as string | null,
		LeaszakaznikIdPrp: null as boolean | null,
		LeasCisSchvalPrp: null as boolean | null,
		PojistCisPu: null as string | null,
		PojistCisExtzaklikv: null as string | null,
		PojistovnaIdPrp: null as boolean | null,
		PojistCisPuPrp: null as boolean | null,
		PojistCisExtzaklikvPrp: null as boolean | null,
		SmluvpartnerId: null as number | null,
		SmluvpartnerIdText: null as string | null,
		SmluvpartnerPzn: null as number | null,
		SmVariaList: [] as number[],
		IsSplittedOrder: null as number | null,
		PracovnikId: null as number | null,
		EstimatedDeliveryTime: null as number | null,
		OrderStage: null as string | null,
		IsElsaProAutosync: null as boolean | null,
	},
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: mutations,
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
